import { render, staticRenderFns } from "./OrderMap.vue?vue&type=template&id=f0bc7484"
import script from "./OrderMap.vue?vue&type=script&lang=js"
export * from "./OrderMap.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports